import { type DialogResources } from "../types"

import wangName from "@/assets/imgs/dialog/wang_name.png"
import nianName from "@/assets/imgs/dialog/nian_name.png"

import wangNormal from "@/assets/imgs/dialog/wang_normal.png"
import wangClose from "@/assets/imgs/dialog/wang_close.png"
import wangBlack from "@/assets/imgs/dialog/wang_black.png"
import wangSigh from "@/assets/imgs/dialog/wang_sigh.png"
import wangGuide from "@/assets/imgs/dialog/wang_guide.png"
import wangCloseGuide from "@/assets/imgs/dialog/wang_close_guide.png"

import nianNormal from "@/assets/imgs/dialog/nian_normal.png"
import nianSmile from "@/assets/imgs/dialog/nian_smile.png"
import nianAwkward from "@/assets/imgs/dialog/nian_awkward.png"
import nianGuide from "@/assets/imgs/dialog/nian_guide.png"
import nianAwkwardGuide from "@/assets/imgs/dialog/nian_awkward_guide.png"
import nianSmileGuide from "@/assets/imgs/dialog/nian_smile_guide.png"
import dialogBackground from "@/assets/imgs/dialog/dialog_bg.png"

export const nameMap = {
    wang: "wang",
    nian: "nian",
    wangGuide: "wangGuide",
    nianGuide: "nianGuide",
}
export const emotionMap = {
    close: "close",
    black: "black",
    sigh: "sigh",
    smile: "smile",
    awkward: "awkward",
    guide: "guide",
    closeGuide: "closeGuide",
    smileGuide: "smileGuide",
    awkwardGuide: "awkwardGuide",
}

export const dialogBackgrounds = {
    common: dialogBackground,
}
export const characterNames = {
    wang: wangName,
    nian: nianName,
}

// 角色立绘资源配置
export const dialogResources: DialogResources = {
    characters: {
        wang: wangNormal,
        nian: nianNormal,
        wangGuide: wangGuide,
        nianGuide: nianGuide,
    },
    emotions: {
        wang: {
            close: wangClose,
            black: wangBlack,
            sigh: wangSigh,
            closeGuide: wangCloseGuide,
        },
        nian: {
            smile: nianSmile,
            awkward: nianAwkward,
            awkwardGuide: nianAwkwardGuide,
            smileGuide: nianSmileGuide,
        },
    },
}
